<div class="navigation-items action-items navigation-border-right">
  <div class="action-icon" *ngIf="searchActive" (click)="resetSearch()">
    <svg-icon src='./assets/icons/showAll.svg' title="{{'projectToolbar.showAll' | translate | uppercase}}"
              class="menu-action-icon svg-icon-gray"></svg-icon>
    <div class="icon-label" [innerHTML]="'projectToolbar.showAll' | translate | uppercase"></div>
  </div>
    <div class="action-icon" (click)="search()">
      <svg-icon src='./assets/icons/search-outline.svg' title="{{'raciTemplate.search' | translate | uppercase}}"
                class="menu-action-icon svg-icon-gray"></svg-icon>
      <div class="icon-label" [innerHTML]="'raciTemplate.search' | translate | uppercase"></div>
    </div>
    <div class="action-icon" (click)="setActiveTab(AdminTab.RaciTemplateNew)">
      <svg-icon src='./assets/icons/add_new.svg' title="{{'raciTemplate.register' | translate | uppercase}}"
                class="menu-action-icon svg-icon-gray"></svg-icon>
      <div class="icon-label" [innerHTML]="'raciTemplate.register' | translate | uppercase"></div>
    </div>
  </div>
<div class="navigation-items action-items" [class.disabled]="disableEdit">
  <div class="action-icon" (click)="setActiveTab(AdminTab.RaciTemplateEdit)">
    <svg-icon src='./assets/icons/create-outline.svg' title="{{'raciTemplate.edit' | translate | uppercase}}"
              class="menu-action-icon svg-icon-gray" [ngClass]="disableEdit ? 'icon-disable' : 'menu-action-icon svg-icon-gray'"></svg-icon>
    <div class="icon-label" [innerHTML]="'raciTemplate.edit' | translate | uppercase"></div>
  </div>
  <div class="action-icon" (click)="copy()">
    <svg-icon src="./assets/icons/copy.svg" align="center" class="menu-action-icon svg-icon-gray" title="COPY TEMPLATE"></svg-icon>
    <div class="icon-label" [innerHTML]="'projectToolbar.buttonCopyTemplate' | translate | uppercase"></div>
  </div>
</div>
